$(() => {
  if (!$('.js-toggle-form').length) {
    return
  }

  let setup = (elm) => {
    let form = $(elm).closest('form')

    let input = $(elm).find('input[name],select[name],textarea[name]')
    let name = input.attr('name')
    // partなど、最初にマッチしたinputがブラケットを持たない単純な名前
    // (例: 行追加用テンプレート内のhidden id) の場合はマッチしないので、
    // その場合はヒント表示用のkeyを求められないだけとして扱う
    let keyMatch = name && name.match(/\[(?!.*\[).*/)
    // partなどkeyを持たないフィールドはdata-toggle-hint-keyで明示されたkeyを優先する
    let key = $(elm).data('toggle-hint-key') || (keyMatch ? keyMatch[0].replace('[', '').replace(']', '') : null)
    let triggerModel = $(elm).data('toggle-trigger-model')
    let triggerKey = $(elm).data('toggle-trigger-key')
    // partなど、トグル対象自身のinput名前空間からトリガー名を推測できないケースのために
    // 明示的なトリガー名(data-toggle-trigger-name)があればそれを優先する
    let triggerName = $(elm).data('toggle-trigger-name') || name.replace(/\[(?!.*\[).*/, '[' + triggerKey + ']')
    let viewableLabelData = $(elm).data('toggle-viewable-label')
    let unviewableLabelData = $(elm).data('toggle-unviewable-label')
    let viewableLabels = viewableLabelData ? viewableLabelData.split(',') : null
    let unviewableLabels = unviewableLabelData ? unviewableLabelData.split(',') : null
    let trigger = form.find('input[name="' + triggerName + '"],select[name="' + triggerName + '"]')
    let hint = form.find('.hint_' + triggerModel + '_' + key)

    let isAvailableForm = () => {
      if (!viewableLabels && !unviewableLabels) {
        // toggle_viewable_label/toggle_unviewable_labelがどちらも未設定の場合は常に表示扱いにする
        return true
      }
      if (trigger.hasClass('js-multiple-select-value')) {
        // checkbox
        let checkedLabels = trigger.parent().find('input:checked').parent().find('label')
        if (unviewableLabels) {
          let checked = true
          checkedLabels.each((i, label) => {
            let checkedLabel = $(label).text()
            if (unviewableLabels.includes(checkedLabel)) {
              checked = false
            }
          })
          return checked
        } else {
          let checked = false
          checkedLabels.each((i, label) => {
            let checkedLabel = $(label).text()
            if (viewableLabels.includes(checkedLabel)) {
              checked = true
            }
          })
          return checked
        }
      } else {
        // radio
        let checkedLabel = trigger.closest('.form-group').find('input:checked').closest('span').find('label').text()
        if (!checkedLabel) {
          // select
          checkedLabel = trigger.closest('.form-group').find('option:selected').text()
        }
        if (unviewableLabels) {
          return !unviewableLabels.includes(checkedLabel)
        } else {
          return viewableLabels.includes(checkedLabel)
        }
      }
    }

    let toggle = () => {
      if (isAvailableForm()) {
        $(elm).show()
        $(elm).removeClass('js-validate-skip')
        $(hint).show()
      } else {
        $(elm).hide()
        $(elm).addClass('js-validate-skip')
        $(elm).removeClass('is-invalid')
        $(elm).find('.is-invalid').removeClass('border-danger')
        $(elm).find('.is-invalid').removeClass('is-invalid')
        $(hint).hide()
      }
    }
   
    if (trigger.hasClass('js-multiple-select-value')) {
      // checkboxの場合
      // trigger付近のinputを監視する
      trigger.parent().find('span.checkbox').on('click', (e) => {
        toggle()
      })
    } else {
      // select, radioの場合
      // triggerを監視する
      trigger.on('change', (e) => {
        toggle()
      })
    }

    $('.submit').on('click', (e) => {
      if (isAvailableForm()) {
        return
      }
      // トルツメフォーム
      if (input.is("input") || input.is("textarea")) {
        input.val('')
      }
    })

    toggle()
  }
  

  $('.js-toggle-form').each((i, e) => {
    setTimeout(() => {
      setup(e)
    })
  })
})
